export const ApiPaths = {
    GET_CONFIGURATION: '/configuration',
    CONVERSATIONS: '/comms/conversations',
    CONVERSATION_TAGS: '/comms/tags',
    CONVERSATION_MEMBERSHIPS: 'comms/conversationmemberships',
    MESSAGES: '/comms/messages',
    UNASSIGNED_QUEUE_SUMMARY: '/queue/unassignedsummary',
    USER_SETTINGS: '/usersettings',
    DISTRICTS: '/districts',

    GET_QUEUE_SUMMARY: (associateId) => 
    {
        let url = '/queue/summary';
        if(associateId)
        {
            url += `/${associateId}`;
        }
        return url;
    },
    GET_QUEUE: (associateId, sort, reversed, limit, offset) => 
    {
        let url = '/queue';
        if(associateId)
        {
            url += `/${associateId}`;
        }
        url += `?sort=${sort}&reversed=${Boolean(reversed)}&offset=${offset}&limit=${limit}`;
        return url;
    },
    GET_UNASSIGNED_QUEUE: (sort, reversed, limit, offset) => `/queue?sort=${sort}&reversed=${Boolean(reversed)}&offset=${offset}&limit=${limit}&unassigned=true`,
    
    DOWNLOAD_FILE_BY_TYPE: (ticketId, documentType) => `/documents/${ticketId}/${documentType}`,
    UPLOAD_FILE: "/clientdocumentmanagement",
    GET_FILES: (ticketId, pageIndex) => `/clientdocumentmanagement?ticketId=${ticketId}&page=${pageIndex}`,
    DELETE_FILE: (fileId) => `/clientdocumentmanagement/${fileId}`,
    UPDATE_FILE_INFO: (ticketId, fileId) => `/clientdocumentmanagement/${fileId}/${ticketId}`,
    RECOVER_FILE: (fileId) => `/clientdocumentmanagement/${fileId}/recover`,
    DOWNLOAD_FILE: (fileId) => `/clientdocumentmanagement/${fileId}`,
    DOWNLOAD_ZIP: (ticketId, zipFileName, documentIds) => {
        let url = `/clientdocumentmanagement/${ticketId}/zip?zipFileName=${zipFileName}`;       
        for (let i = 0; i < documentIds.length; i++) {
            url += `&documentIds=${documentIds[i]}`
        }
        return url;
    },
    GET_ACCOUNT_SETTINGS: `accountsettings`,
    UPDATE_ACCOUNT_LANGUAGE: (accountId) => `accountsettings/language/${accountId}`,
    AUDIT: 'audit',
    RESET_AUTHORIZE: (ticketId, isPrimary) => `authorize/${ticketId}?isPrimary=${Boolean(isPrimary)}`,
    SEARCH_CLIENTS: (searchCriteria) => `clients?query=${searchCriteria}`,
    GET_ACCOUNT_HISTORY: (id) => `clients/${id}/accounthistory`,
    GET_SECURITY_INFO: (id) => `clients/${id}/securityinfo`,
    GET_CLIENT: (id) => `clients/${id}`,
    GET_FILED_RETURNS: (returnId, taxYear) => `returns/${returnId}/${taxYear}/filed-returns`,
    GET_FILED: (returnId, taxYear) => `returns/${returnId}/${taxYear}/filed`,
    GET_ASSOCIATED_RETURNS: (returnId, taxYear) => `returns/${returnId}/${taxYear}/associated`,
    GET_PARTY: (partyId) => `clients/${partyId}/party`,

    DOCUMENT_REVIEW: (ticketId) => `documentreview/${ticketId}`,
    RESET_SIGNATURE_PAGE: (ticketId, workflowTaskId) => `documentreview/${ticketId}/${workflowTaskId}`,
    SEARCH_EMPLOYEE: (searchString, onlyMyOffices, impersonateUser) => {
        let url = `/employee/search?searchString=${searchString}`

        if (onlyMyOffices === true) {
            url += '&onlyMyOffices=true'
        }

        if (!!impersonateUser) {
            url += `&impersonateUser=${impersonateUser}`
        }
        return url;
    },
    RESET_INTERVIEW: (ticketId) => `interview/${ticketId}`,
    REPAIR_INTERVIEW: (ticketId) => `interview/${ticketId}/repair`,

    GET_CONVERSATION: (userId, userType, product, offset) =>`/comms/conversations?userId=${userId}&userType=${userType}&tags=${product}&offset=${offset}`,
    GET_MEMBERBSHIPS_BY_CONVERSATION_ID: (conversationId) => `/comms/conversationmemberships?conversationId=${conversationId}`,
    GET_MESSAGES: (conversationId, offset, limit) => `/comms/messages?conversationId=${conversationId}&offset=${offset}&limit=${limit}`,

    TOUCH_TICKET: (ticketId) => `/tickets/${ticketId}/touch`,
    GET_UNREAD_MESSAGES: (conversationId) => `/comms/conversations/${conversationId}/unreadmessages`,
    MARK_MESSAGE_READ: (maxMessageId) => `/comms/messages/${maxMessageId}/read`,

    GET_OFFICES: (impersonateId) => 
    {
        let url = '/offices';
        if (!!impersonateId) {
            url += `/${impersonateId}`;
        }
        return url;
    },
    GET_ASSOCIATE_OFFICES: (associateId) => `/employee/activeoffices/${associateId}`,
    GET_EMPLOYEE_INFO: (associateId) => `/employee/info/${associateId}`,
    ADD_EMPLOYEE_OFFICES: (associateId) => `/employee/activeoffices/${associateId}`,
    GET_OFFICE_SUMMARY: (officeId) => `/offices/${officeId}/summary`,
    GET_EMPLOYEES: (officeId, offset, sortType, reversed) => `/employee/office/${officeId}?offset=${offset}&sort=${sortType}&reverse=${Boolean(reversed)}`,
    GET_DISTRICT_OFFICES: (sort, reversed, offset, limit, districtIdFilter) => `/offices/summaries?sort=${sort}&reversed=${Boolean(reversed)}&offset=${offset}&limit=${limit}&filter=${districtIdFilter}`,
    COMPLETE_PAYMENT: (ticketId) => `payment/${ticketId}`,

    PREPARE_RETURN: (ticketId) => `preparereturn/${ticketId}`,
    UPDATE_PREPARE_RETURN: (ticketId) => `preparereturn/${ticketId}/additionaldocs`,

    GET_USER_SETTINGS: (associateId) => `/usersettings/${associateId}`,

    QUERY_TICKETS: (queryParams) => `tickets${queryParams}`,
    GET_TICKET: (ticketId) => `tickets/${ticketId}`,
    UPDATE_TICKET: (ticketId) => `tickets/${ticketId}`,
    COMPLETE_TICKET_WORKFLOW: (ticketId) => `tickets/${ticketId}/workflowtasks`,
    GET_ELIGIBLE_ADD_ONS: (ticketId) => `tickets/${ticketId}/eligibleProductAddons`,
    ASSIGN_TICKETS: (associateId) => `/tickets/reassign/${associateId}`,
    TOUCH_TICKET: (ticketId) => `/tickets/${ticketId}/touch`,
    GET_TICKET_NOTES: (ticketId) => `/tickets/notes/${ticketId}`,
    ADD_TICKET_NOTE: '/tickets/notes',
    GET_TICKET_SUMMARY: (associateId, query) => 
    {
        let url =  '/TicketSummary?';
        if(associateId)
        {
            url += `associateId=${associateId}&`;
        }
        url += `${query}&$top=${25}&$count=true`;
        return url;
    }
};